import styled from 'styled-components';
import { breakpoints } from 'config/config';

interface FarmContactsWrapperProps { }

export const FarmContactsWrapper = styled.div<FarmContactsWrapperProps>`
  display: grid;
  grid-template-columns: 1fr;

  @media (max-width: ${breakpoints.xs}px) {
    padding: 20px;
  }

  .contact-item:nth-child(odd) {
    background-color: ${(props) => props.theme.grayBg};
  }

  .contact-item:nth-child(even) {
    background-color: ${(props) => props.theme.white};
  }

  .contact-item {
    line-height: 24px;
    display: flex;
    gap: 20px;
    padding: 10px 20px;
    font-size: 16px;
    font-weight: 500;
    color: ${(props) => props.theme.black};
    border: 1px solid ${(props) => props.theme.whiteSmoke};
  }

  @media only screen and (max-width: ${breakpoints.lg}px) {
    .contact-item {
      font-size: 1rem;
    }
  }
`
